module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    301重定向\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('p', {
    staticClass: "left-desc"
  }, [_vm._v("是否开启重定向")]), _vm._v(" "), _c('div', {
    staticClass: "right-select-box flex1 flex",
    attrs: {
      "id": "upgradeSpace"
    }
  }, _vm._l((_vm.choose), function(item, index) {
    return _c('span', {
      staticClass: "another-option flex1per2",
      class: {
        'selected': _vm.redirect == item.value
      },
      staticStyle: {
        "margin-right": "0.2rem"
      },
      on: {
        "click": function($event) {
          _vm.Choose(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), (_vm.redirect === 'open') ? _c('div', {
    staticClass: "form-group-item"
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "8em",
      "title": "重定向URL"
    },
    model: {
      value: (_vm.sdomain),
      callback: function($$v) {
        _vm.sdomain = $$v
      },
      expression: "sdomain"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".5rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("如果您的网站已经转移，或者网站临时维护，您可以利用此功能，将本站的全部访问转发到您指定的其他地址")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9f7f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/redirecturl.vue
// module id = Y/3C
// module chunks = 1